import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function StudentForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  // Use environment variable for API base URL
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      console.log('Sending request to backend with email:', email);
      const response = await axios.post(`${API_BASE_URL}/student/reset-password-request`, { email });
      console.log('Backend response:', response.data);
      setMessage(response.data.message);
      setIsError(false);
      setTimeout(() => {
        console.log('Navigating to /student-login');
        navigate('/student-login');
      }, 2000);
    } catch (error) {
      console.error('Error in reset password request:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Something went wrong.';
      setMessage(errorMessage);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseMessage = () => {
    setMessage('');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: '100vh',
      }}
    >
      <div
        style={{
          flex: '0 0 60%',
          display: isMobile ? 'none' : 'block',
          backgroundImage: 'url("../images/studentloginimg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div
        style={{
          flex: '0 0 40%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)',
          padding: '10px',
          overflowY: 'hidden',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '400px',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
            textAlign: 'center',
          }}
        >
          <h2 style={{ marginBottom: '16px', color: 'purple', fontSize: '24px' }}>
            Forgot Password
          </h2>
          {message && (
            <div
              style={{
                backgroundColor: isError ? '#FFCCCC' : '#F3E8FF',
                color: '#6B21A8',
                fontFamily: "'Roboto', sans-serif",
                padding: '8px',
                borderRadius: '8px',
                textAlign: 'center',
                fontSize: '14px',
                maxWidth: '300px',
                width: '100%',
                margin: '0 auto 16px auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                animation: 'slideInFromRight 0.5s ease-out',
              }}
            >
              <span>{message}</span>
              <FontAwesomeIcon
                icon={faTimes}
                style={{
                  cursor: 'pointer',
                  fontSize: '12px',
                  color: '#6B21A8',
                  fontFamily: "'Roboto', sans-serif",
                }}
                onClick={handleCloseMessage}
                aria-label="Close message"
              />
            </div>
          )}
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'center',
              marginTop: '2rem',
            }}
          >
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              style={{
                padding: '10px 14px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px',
                width: '100%',
                opacity: loading ? 0.6 : 1,
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '5px 20px',
                backgroundImage: loading
                  ? 'linear-gradient(#ccc, #ccc), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)'
                  : 'linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                color: 'purple',
                fontWeight: 'bold',
                fontSize: '14px',
                border: '2px solid transparent',
                borderRadius: '30px',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                marginTop: '12px',
                maxWidth: '300px',
                width: '45%',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.transform = 'scale(1.03)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                }
              }}
              onMouseOut={(e) => {
                if (!loading) {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                }
              }}
            >
              {loading ? 'Sending...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
      <style>
        {`
          @keyframes slideInFromRight {
            0% {
              transform: translateX(100%);
              opacity: 0;
            }
            100% {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}

export default StudentForgotPassword;